document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('.kg-video-overlay, .kg-video-player-container').forEach(function(element) {
        element.parentNode.removeChild(element);});
    document.querySelectorAll('video').forEach(function(element) {
        element.setAttribute('controls', 'true');});

    let links = document.querySelectorAll('a');
    links.forEach(function(link) {
        if (link.hostname != window.location.hostname) {
            link.target = '_blank';
        }
    });
});
